
import { mixins } from "vue-class-component";
import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class Alert extends Vue {
  @Prop({ default: "SUCCESS" }) readonly status!: string;
  @Prop({ default: "Message here" }) readonly message!: string;
}
